import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";

export default function CompanyClosingSection() {
  const { t } = useLanguage();
  const copy = t("home.closing");

  return (
    <section id="company-closing" className="relative overflow-hidden bg-white py-20 sm:py-28">
      <div className="pointer-events-none absolute -right-28 top-0 h-96 w-96 rounded-full bg-brand-100/70 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto max-w-5xl px-5 text-center sm:px-8">
        <p className="home-eyebrow">{copy.eyebrow}</p>
        <h2 className="mx-auto mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.03] tracking-[-.065em] text-slate-950 sm:text-6xl">{copy.title}</h2>
        <p className="mx-auto mt-6 max-w-xl text-base leading-7 text-slate-600">{copy.body}</p>
        <div className="mt-9 flex flex-wrap justify-center gap-3"><Link to="/about" className="inline-flex items-center gap-2 rounded-xl bg-brand-700 px-5 py-3.5 text-sm font-bold text-white transition hover:bg-brand-800 focus:outline-none focus:ring-2 focus:ring-brand focus:ring-offset-2">{copy.about} <ArrowRight className="h-4 w-4" /></Link></div>
      </div>
    </section>
  );
}
